import React from 'react';

// Outline megaphone matching the Feather set (react-icons 3.11 has no Lucide megaphone; the nav's IoMdMegaphone is filled).
// Same 24-grid / 2px stroke as react-icons/fi. Used where the spec shows the outline icon (help centre + help panel).
const MegaphoneIcon: React.FC<{ className?: string }> = ({ className }) =>
    <svg className={className} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M3 11l18-5v12L3 14v-3z" />
        <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
    </svg>;

export default MegaphoneIcon;
